import { createSlice } from "@reduxjs/toolkit";

export const commonSlice = createSlice({
    name: "commonData",
    initialState: {
        offsetTag: 0,
        pageSizeTag: 10,
        searchText: "",
        fileType: "",
        searchMode: "",
        tagNames: [],
        tagNameFlag : false,
        showMoreTag : false,
        loadingTag : null,
        tagList: [],
        totalCountTag: 0,
        searchType: null,
        locationName: "",
        selectDate: null,
        textTrigger: false,
        hasMoreTag : false,
    },

    reducers: {
        setOffsetTag: (state, action) => {
            state.offsetTag = action.payload;
        },
        setPageSizeTag: (state, action) => {
            state.pageSizeTag = action.payload;
        },
        setSearchText: (state, action) => {
            state.searchText = action.payload;
        },
        setFileType: (state, action) => {
            state.fileType = action.payload;
        },
        setSearchMode: (state, action) => {
            state.searchMode = action.payload;
        },
        setShowMoreTag: (state, action) => {
            state.showMoreTag = action.payload;
        },
        setHasMoreTag: (state, action) => {
            state.hasMoreTag = action.payload;
        },
        setLoadingTag: (state, action) => {
            state.loadingTag = action.payload;
        },
        setTextTrigger: (state, action) => {
            state.textTrigger = action.payload;
        },
        setTagList: (state, action) => {
            state.tagList = action.payload;
        },
        setTotalCountTag: (state, action) => {
            state.totalCountTag = action.payload;
        },
        setSearchType: (state, action) => {
            state.searchType = action.payload;
        },
        setLocationName: (state, action) => {
            state.locationName = action.payload;
        },
        setSelectDate: (state, action) => {
            state.selectDate = action.payload;
        },
        setTagNames: (state, action) => {
            state.tagNames = action.payload;
        },
        setTagNameFlag: (state, action) => {
            state.tagNameFlag = action.payload;
        },
    },
});

export const { setOffsetTag, setPageSizeTag, setSearchText, setFileType, setSearchMode, setShowMoreTag, 
    setHasMoreTag, setLoadingTag, setTextTrigger, setTagList, setTotalCountTag, setSearchType, setLocationName, setSelectDate, setTagNames, setTagNameFlag } = commonSlice.actions;

export default commonSlice.reducer;